import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PlanSubjectType } from "../../../types/PlanSubject";

const initialState: PlanSubjectType = {
    id: "",
    status: false,
    idPlan: "",
    idSubject: "",
    semester: 0,
    isCore: false,
    hasExam: false,
    level: 0,
};

export const planSubjectSlice = createSlice({
    name: 'planSubjectForm',
    initialState,
    reducers: {
        setUpdatePlanSubjectData: (state, action: PayloadAction<PlanSubjectType>) => {
            return { ...state, ...action.payload }
        },
        resetUpdatePlanSubjectData: (state) => {
            return initialState
        }
    }
});

export const { setUpdatePlanSubjectData, resetUpdatePlanSubjectData } = planSubjectSlice.actions;
export default planSubjectSlice.reducer;